webpackJsonp([143062475088934],{

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Fellows = __webpack_require__(25);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _BioCard = __webpack_require__(127);
	
	var _BioCard2 = _interopRequireDefault(_BioCard);
	
	var _BioTray = __webpack_require__(114);
	
	var _BioTray2 = _interopRequireDefault(_BioTray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TheSchedule = function (_React$Component) {
	    _inherits(TheSchedule, _React$Component);
	
	    function TheSchedule(props) {
	        _classCallCheck(this, TheSchedule);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeProfile: null
	        };
	        return _this;
	    }
	
	    TheSchedule.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: 'bg-grey' },
	            _react2.default.createElement(
	                'div',
	                { className: 'academy-schedule block standard-spacing' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'h1 large' },
	                    'Explore a typical week'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'schedule-intro' },
	                    'Global Citizen Academy offers an engaging blend of interactive online learning, discussions with leading innovators, real-world projects, and peer collaboration.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'alt' },
	                    'Explore the sample schedule below to get a taste of the exploration, community, and growth that\u2019s possible with Global Citizen Academy. To accommodate different time zones and schedules, there will be multiple sections for each course. Your schedule may not look exactly like the sample below, but we\'ll do our absolute best to make sure every student can join a session that works for them!'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'grid-outer grid-rows' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-5 bg-green' },
	                        _react2.default.createElement('div', { className: 'empty' }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'MONDAY'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'TUESDAY'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'WEDNESDAY'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'THURSDAY'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-5' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-dark card time-card' },
	                            'MORNING'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Leadership As A Practice: Seminar'
	                            ),
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '19 students / 90 minutes'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Gain clarity, confidence and concrete skills to connect the values that drive you with the change you want to see in the world.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Speaker Series: Leadership in Action '
	                            ),
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '60 minutes'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Join weekly conversations with today\u2019s most innovative leaders.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Leadership As A Practice: Learning Group'
	                            ),
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '6-8 students / 60 minutes'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Discuss the concepts from the seminar in a supportive small group setting with peers from across the globe.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Leadership As A Practice'
	                            ),
	                            _react2.default.createElement(
	                                'em',
	                                null,
	                                '6-8 students / 60 minutes'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Discuss the concepts from the seminar in a supportive small group setting with peers from across the globe.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-2 afternoon' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-dark card time-card' },
	                            'AFTERNOON'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Volunteer with our Impact Partners'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Put theory into practice by volunteering with one of our impact partners working at the forefront of global challenges. [Optional]'
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Personalized Mentorship'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Connect one-on-one with your personal mentor to set leadership goals and receive guidance on topics spanning college, career, and personal growth.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-2 evening' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-dark card time-card' },
	                            'EVENING'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Reflect & Prep'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Prepare for class with thought-provoking podcasts, TEDtalks, readings, and prompts for reflection.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-2 evening' },
	                        _react2.default.createElement('div', { className: 'bg-dark card time-card' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white card schedule-card' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Student-Led Clubs & Events'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Connect with classmates across the world on the Academy\u2019s Discord server which is overflowing with student-led clubs, discussions, events, resources, and collaborative projects.'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return TheSchedule;
	}(_react2.default.Component);
	
	exports.default = TheSchedule;
	module.exports = exports['default'];

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Issues":"src-components-_Redesign-Issues----Issues-module---Issues---1HQAK","Issues__Wrapper":"src-components-_Redesign-Issues----Issues-module---Issues__Wrapper---FZ35j","Issues__Headline":"src-components-_Redesign-Issues----Issues-module---Issues__Headline---YDJEw","Issues__Copy":"src-components-_Redesign-Issues----Issues-module---Issues__Copy---3G5Kl","Issues__Text":"src-components-_Redesign-Issues----Issues-module---Issues__Text---240N6","Locations":"src-components-_Redesign-Issues----Issues-module---Locations---3_Tmf","Location":"src-components-_Redesign-Issues----Issues-module---Location---3WTND","Location__Copy":"src-components-_Redesign-Issues----Issues-module---Location__Copy---3DNIg","Location__Arrow":"src-components-_Redesign-Issues----Issues-module---Location__Arrow---1uqiY"};

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IssuesModule = __webpack_require__(379);
	
	var _IssuesModule2 = _interopRequireDefault(_IssuesModule);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Issues = function Issues(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _IssuesModule2.default.Issues },
	    _react2.default.createElement(
	      'div',
	      { className: _IssuesModule2.default.Issues__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _IssuesModule2.default.Issues__Text },
	        _react2.default.createElement(
	          'h2',
	          { className: 'h2 ' + _IssuesModule2.default.Issues__Headline },
	          props.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _IssuesModule2.default.Issues__Copy },
	          props.text
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _IssuesModule2.default.Locations },
	        props.countries.map(function (country, i) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: country.link, className: _IssuesModule2.default.Location, key: i, title: 'View ' + country.title + ' destination' },
	            _react2.default.createElement(_gatsbyImage2.default, { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 },
	              sizes: country.backgroundImage.sizes }),
	            _react2.default.createElement(
	              'h3',
	              null,
	              country.title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _IssuesModule2.default.Location__Copy },
	              country.description
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _IssuesModule2.default.Location__Arrow },
	              _react2.default.createElement('img', { src: '/images/icon-circle-arrow.svg', alt: 'arrow link' })
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _IssuesModule2.default.Issues__Text + ' text-center' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Not sure which destination is right for you? ',
	          _react2.default.createElement(_Button2.default, { text: 'Take the Quiz', href: props.link })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Issues;
	module.exports = exports['default'];

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gsap = __webpack_require__(29);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Testimonials = __webpack_require__(130);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _AdmissionsSignup = __webpack_require__(129);
	
	var _AdmissionsSignup2 = _interopRequireDefault(_AdmissionsSignup);
	
	var _Signup = __webpack_require__(70);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Issues = __webpack_require__(346);
	
	var _Issues2 = _interopRequireDefault(_Issues);
	
	var _Fellows = __webpack_require__(296);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _TheSchedule = __webpack_require__(344);
	
	var _TheSchedule2 = _interopRequireDefault(_TheSchedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	
	    // import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
	    // require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	}
	
	var Impact = function (_React$Component) {
	    _inherits(Impact, _React$Component);
	
	    function Impact(props) {
	        _classCallCheck(this, Impact);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            controller: null
	        };
	        return _this;
	    }
	
	    Impact.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.controller = new ScrollMagic.Controller();
	
	        this.setState({
	            controller: this.controller
	        });
	
	        var timeline = this.refs.timeline;
	
	        if (timeline) {
	            var points = Array.from(timeline.getElementsByClassName('timeline-point'));
	
	            points.map(function (point) {
	                var progressBar = point.getElementsByClassName('timeline-progress-bar')[0];
	                if (progressBar) {
	                    // const toGrow = (point.clientHeight + 80) * 3
	                    // const TL = new TimelineMax()
	                    // TL.to(progressBar, 0.45, { height: toGrow})
	
	                    var progressScroll = new ScrollMagic.Scene({
	                        triggerElement: progressBar,
	                        triggerHook: 0.5
	                    }).setClassToggle(point, 'extended').addTo(_this2.controller);
	                    // .addIndicators()
	                    // console.log('TO GROW === ', point.parentNode, toGrow);
	                }
	            });
	        }
	    };
	
	    Impact.prototype.componentWillUnmount = function componentWillUnmount() {
	        // this.state.controller.destroy(true)
	        // this.controller.destroy(true)
	    };
	
	    Impact.prototype.scrollTo = function scrollTo(id) {
	        this.refs[id].scrollIntoView({ behavior: 'smooth' });
	    };
	
	    Impact.prototype.render = function render() {
	        var _this3 = this;
	
	        var pageData = this.props.pathContext.data;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'page-redesign page-our-impact' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hero-content' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'pre-header font-bold' },
	                        'Our Impact'
	                    ),
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'h1 large' },
	                        'From Our Founder'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'When I finished high school I was determined to find an experience that would shape my values, identity and sense of purpose before setting foot on a college campus. I\u2019d been a good student, checked the boxes, and gotten into Stanford.  But I knew in my gut, something was missing: I\u2019d let school interfere with my real education.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'Ever since, I\u2019ve been obsessed with the historic opportunity to create a new -- and better -- cultural template for the transition into adulthood.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'There\u2019s a developmental magic in the moment when a young person has the maturity to leave home but hasn\u2019t yet fixed their values or identity. But in today\u2019s world, high-achieving students hustle toward an abstract finish line; they\'re discouraged from stepping off the treadmill -- let alone adjusting the incline or speed.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'Since 2010, Global Citizen Year has helped over 1,500 exceptional young people find their purpose, their people and their power to change the world. We\u2019re changing the ',
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'who'
	                        ),
	                        ' and ',
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'how'
	                        ),
	                        ' of our next generation leaders in order to create a more inclusive, equitable, and sustainable future.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'Today we have a world-class team, a stellar track-record, and a dynamic (and growing!) community of alumni, partners and donors worldwide. Together we\u2019re building the world\u2019s launch pad for changemakers -- equipping leaders who reflect society\u2019s diversity and are equipped to change the world, for good.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'Will you join us?'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'sig-wrapper' },
	                        _react2.default.createElement('img', { src: '/images/impact-headshot.jpg', alt: 'gcy impact', style: { width: '250px', marginTop: '20px' } }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('img', { className: 'sig', src: 'https://images.ctfassets.net/j91b9gwu8s3q/XTPyNapXHiFugwlhOLaGR/92ab3bb63a02f5e1d5648798d1b31750/Untitled_design__11___1_.png', style: { maxWidth: '150px' } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('img', { src: '/images/yellow-strokes-tall.png', alt: '', style: { position: 'absolute', right: '0' }, id: 'impact-strokes' })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'bg-dark-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-page-navigation bg-grey capper', style: { transform: 'translateY(-50%)' } },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'flex' },
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'hoverlink', onClick: function onClick() {
	                                        return _this3.scrollTo('by-the-numbers');
	                                    } },
	                                'By The Numbers'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'hoverlink', onClick: function onClick() {
	                                        return _this3.scrollTo('a-transformative-experience');
	                                    } },
	                                'A Transformative Experience'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'hoverlink', onClick: function onClick() {
	                                        return _this3.scrollTo('a-lifetime-of-impact');
	                                    } },
	                                'A Lifetime of Impact'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block two-col-block by-numbers standard-spacing capper', ref: 'by-the-numbers' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'h1' },
	                            'BY THE NUMBERS'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'grid-2' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'boldItal' },
	                                '2010'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Founded'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'boldItal' },
	                                '1500'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'New Leaders'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'boldItal' },
	                                '68'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Countries'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'boldItal' },
	                                '$25M'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Scholarships'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing block-stats-cards capper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'stats-card' },
	                        _react2.default.createElement('img', { src: '/images/impact/card1.jpg', alt: 'gcy card image' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-content' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '51%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'of Global Citizen Year students are from low income backgrounds'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'caps' },
	                                'compared to'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '16%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'of gap year participants nationally'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'stats-card' },
	                        _react2.default.createElement('img', { src: '/images/impact/card2.jpg', alt: 'gcy card image' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-content' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '46%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'of Global Citizen Year students are students of color'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'caps' },
	                                'compared to'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '16%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'of gap year participants nationally'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'stats-card' },
	                        _react2.default.createElement('img', { src: '/images/impact/card3.jpg', alt: 'gcy card image' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-content' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '80%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'of all Global Citizen Year students receive ',
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    'need-based financial aid'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'caps' },
	                                'and'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                '30%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'of all Global Citizen Year students receive ',
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    'full financial aid'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing capper block-transform', ref: 'a-transformative-experience' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'pre-header font-bold orange' },
	                        'A Transformative Experience'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h1 large boldItal' },
	                        'Learn how',
	                        _react2.default.createElement('br', null),
	                        'Global Citizen',
	                        _react2.default.createElement('br', null),
	                        'Year alumni...'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block block-diverse two-col-block' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-center' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bar-outer' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bar-wrap' },
	                                    _react2.default.createElement('span', { className: 'bar-fill orange', style: { width: '23%' } })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bar-wrap' },
	                                    _react2.default.createElement('span', { className: 'bar-fill yellow', style: { width: '85%' } })
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '23% ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _react2.default.createElement('img', { src: '/images/impact/arrow.svg' })
	                                    ),
	                                    ' 85%'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Emotionally prepared for college'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bar-wrap' },
	                                    _react2.default.createElement('span', { className: 'bar-fill orange', style: { width: '21%' } })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bar-wrap' },
	                                    _react2.default.createElement('span', { className: 'bar-fill yellow', style: { width: '76%' } })
	                                ),
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    '21% ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _react2.default.createElement('img', { src: '/images/impact/arrow.svg' })
	                                    ),
	                                    ' 76%'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Have clear goals for college'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginTop: '40px' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'dot-wrap' },
	                                    _react2.default.createElement('span', { className: 'dot orange' }),
	                                    'BEFORE'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'dot-wrap' },
	                                    _react2.default.createElement('span', { className: 'dot yellow' }),
	                                    'AFTER'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Maximize College'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Alumni have the insights and agency to make the most of college'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'boldItal' },
	                                    '91%'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'say their Global Citizen Year has been instrumental in shaping their college experience'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'boldItal' },
	                                    '90%'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'say their Global Citizen Year increased their self-confidence'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'flex' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'boldItal' },
	                                    '78%'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'say their Global Citizen Year helped them develop the agency to make the most of college'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('img', { className: 'strokes', src: '/images/impact/yellow-strokes-alt.png', alt: 'strokes' })
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'standard-spacing no-padding-top no-padding-bottom remove-padding-tablet' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block quote-block standard-spacing bg-black text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large color-white' },
	                        'Global Citizen Year changed the way I see my education. It isn\'t a pipeline. It\'s a complicated network of roads, highways, and choices all of which could take me down different courses. My Global Citizen Year is my GPS."'
	                    ),
	                    _react2.default.createElement('img', { src: '/images/impact/jj-head.png', className: 'headshot', alt: 'author headshot' }),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'credit mini color-white' },
	                        'J.I. Cruz, Senegal \'15, American University \'19'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing two-col-block align-middle' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'h1 boldItal giant' },
	                            '91%'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'font-bold' },
	                            'of Fellows placed in Brazil, Ecuador or Senegal return proficient in a second language'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Apply Cross-cultural Skills'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Alumni use curiosity and empathy to work effectively across lines of difference'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '97%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'are able to see the world from someone else\u2019s perspective'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '97%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'are able to work cooperatively with diverse groups'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '97%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'have tolerance for others with different beliefs'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'standard-spacing no-padding-top no-padding-bottom remove-padding-tablet' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block quote-block standard-spacing bg-black text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large color-white' },
	                        'My Global Citizen Year is the defining, pivotal point of my life, and has impacted every choice I\'ve made since. I am a different human being on a cellular level. The way I interact with the world is different. I used to be closed off to everything because of uncertainty and fear. Now I aim higher and dream bigger.\u201D\u201D'
	                    ),
	                    _react2.default.createElement('img', { src: '/images/impact/allie-head.png', className: 'headshot', alt: 'author headshot' }),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'credit mini color-white' },
	                        'Allie McKinney, Senegal \'14, University of North Carolina \'18'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing two-col-block' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/images/impact/citizens.jpg', alt: 'transformative photo' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Become Engaged Citizens'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Alumni demonstrate the courage to stand up for their beliefs'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '91%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'believe it is \u2018very important\u2019 or \u2018essential\u2019 to challenge inequity in all its forms'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '97%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'have challeged others on issues of discrimination during the past year'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '99%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'recognize the biases that affect their own thinking'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'standard-spacing no-padding-top no-padding-bottom remove-padding-tablet' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block quote-block standard-spacing bg-black text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large color-white' },
	                        'Today, I have the confidence that I need to learn and grow in any situation. Because of Global Citizen Year, I\u2019m more open to taking risks, embracing failures, and chasing uncertainty.\u201D'
	                    ),
	                    _react2.default.createElement('img', { src: '/images/impact/mouna-head.png', className: 'headshot', alt: 'author headshot' }),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'credit mini color-white' },
	                        'Mouna Algahaithi, Senegal 2014, University of Wisconsin Madison 2019',
	                        _react2.default.createElement('br', null),
	                        'Education Specialist, PBS'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing two-col-block' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/images/impact/chart.png', alt: 'transformative photo' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Lead with Purpose'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Alumni are aligning their work with their convictions'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '84%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'believe their Global Citizen Year made them more aware of their strengths and weaknesses as a leader'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '77%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'believe their Global Citizen Year helped them develop a clearer sense of purpose'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex' },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'boldItal' },
	                                '72%'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'believe their Global Citizen Year influenced the career path they chose to pursue'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'standard-spacing no-padding-top no-padding-bottom remove-padding-tablet' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block quote-block standard-spacing bg-black text-center' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'large color-white' },
	                        'In Ecuador I discovered an interest at the intersection of energy and sustainability, and this has informed everything I\u2019ve done since. My Global Citizen Year gave me the space to discern what I\u2019m passionate about, and the courage to pursue it.\u201D'
	                    ),
	                    _react2.default.createElement('img', { src: '/images/impact/jordan-head.png', className: 'headshot', alt: 'author headshot' }),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'credit mini color-white' },
	                        'Jordan Lee, Ecuador 2013, Yale University 2017',
	                        _react2.default.createElement('br', null),
	                        'Research Analyst, McKinsey & Company'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing block-life-impact', ref: 'a-lifetime-of-impact' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'pre-header font-bold orange' },
	                        'A Lifetime of Impact'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h1' },
	                        'Alumni are leading lives that change the world'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'h3' },
	                        'Our alumni are thriving in colleges and careers in over 60 countries. They\u2019re being honored with prestigious awards and recognition and are working for influential organizations and companies. Global Citizen Year alumni are already having an outsized impact on society; and they\u2019re just getting started!'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'logos' },
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/fulbright.svg', alt: 'logo' }),
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/tesla.svg', alt: 'logo' }),
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/gates.svg', alt: 'logo' }),
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/ashoka.png', alt: 'logo', style: { width: '100px' } }),
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/tfa.svg', alt: 'logo' }),
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/un.svg', alt: 'logo' }),
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/amazon.svg', alt: 'logo' })
	                    )
	                ),
	                _react2.default.createElement('img', { className: 'strokes', src: '/images/impact/yellow-strokes-alt.png', alt: 'strokes' })
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'bg-dark-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block standard-spacing block-download' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/images/impact/impact_logos/booklet.png', alt: 'booklet mockup' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'boldItal' },
	                            'Download our Alumni Outcomes Report'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Marking a decade of impact, our Alumni Outcomes Report shows how our programs are equipping students with a sense of purpose, a global perspective, and the agency to take ownership of their education.'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://downloads.ctfassets.net/j91b9gwu8s3q/32J3zMCSMMQys86qYmwq0I/3b6474e8c8e1e301bd0121c0cc4e71a6/20-0702_GCY_Impact_Report.pdf', target: '_blank', className: 'hoverlink' },
	                            'Download Now'
	                        )
	                    )
	                )
	            ),
	            this.props.data && this.props.data.page.fellowCards && _react2.default.createElement(_Fellows2.default, {
	                title: 'Hear from Global Citizen Year Students',
	                cards: this.props.data.page.fellowCards
	            }),
	            _react2.default.createElement(
	                'section',
	                { className: 'block-cta bg-dark-grey' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content capper standard-spacing text-center' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'h1 text-center color-white' },
	                        'The Future is up to you'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'text-center color-white' },
	                        'Join our ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/partners-and-supporters/', className: 'color-orange' },
	                            'amazing community of donors'
	                        ),
	                        ' to launch the leaders the world needs now.',
	                        _react2.default.createElement('br', null),
	                        'Global Citizen Year is a 501c3, non-profit, and all contributions are fully tax-deductible.'
	                    ),
	                    _react2.default.createElement(_Button2.default, {
	                        text: 'Donate',
	                        href: '/donate/',
	                        hoverwhite: true
	                    })
	                )
	            )
	        );
	    };
	
	    return Impact;
	}(_react2.default.Component);
	
	exports.default = Impact;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-our-impact-js-d682f564860fddae4bc9.js